import { BasicParallelEnumerable } from "../BasicParallelEnumerable";
export const fromParallel = (type, generator) => {
    return new BasicParallelEnumerable({
        generator,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        type,
    });
};
